import { render } from "./VoiceRecord.vue?vue&type=template&id=afd9afce&scoped=true"
import script from "./VoiceRecord.vue?vue&type=script&lang=js"
export * from "./VoiceRecord.vue?vue&type=script&lang=js"

import "./VoiceRecord.vue?vue&type=style&index=0&id=afd9afce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd9afce"]])

export default __exports__